// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AutomationSubscriptions } from '../../../../types/server/modules/automation/subscriptions';

export type * from '../../../../types/server/modules/automation/subscriptions';

export const createSubscriptions = ( requests: Requests ): AutomationSubscriptions => ({
  Rules: ( params, onChange ) => {
          return requests.subscribe( `/rules/:id?`, params, 'Rules', onChange );
          },
  RuleDefinitions: ( params, onChange ) => {
          return requests.subscribe( `/rule-definitions/:id?`, params, 'RuleDefinitions', onChange );
          },
  AutomationRequests: ( params, onChange ) => {
          return requests.subscribe( `/automation-requests/:id?`, params, 'AutomationRequests', onChange );
          },
  RuleExecutions: ( params, onChange ) => {
          return requests.subscribe( `/rule-executions/:id?`, params, 'RuleExecutions', onChange );
          },
  RuleExecutionBatches: ( params, onChange ) => {
          return requests.subscribe( `/rule-execution-batches/:correlationId?`, params, 'RuleExecutionBatches', onChange );
          }
});
